<p *ngIf="ring.ringSize">Ring Size: {{ring.ringSize}} 
  <ng-template #popContent>
    <select class="form-control" [(ngModel)]="ring.ringSize" name="ring-size" (change)="p.close(); updateShoppingCart(ring)">
      <option *ngFor="let size of ringSizes; let i = index" [value]="size"
        ng-selected="size === ring.ringSize">{{size}}</option>
    </select>
  </ng-template>
  <button type="button" class="btn btn-link" [autoClose]="false" triggers="manual" #p="ngbPopover" (click)="p.open()" [ngbPopover]="popContent" popoverTitle="Choose a Ring Size">Edit</button>
</p>
